import { type JSX } from 'react'

import { SelectListbox, type SelectListboxProps } from 'base-ui'

import { ProductSearchRefinementPriceListboxBody } from './ProductSearchRefinementPriceListboxBody'

export const ProductSearchRefinementPriceListbox = <
  OptionValue extends NonNullable<unknown>,
  Multiple extends boolean,
>(
  props: SelectListboxProps<OptionValue, Multiple>,
): JSX.Element => (
  <SelectListbox
    {...props}
    slots={{ body: ProductSearchRefinementPriceListboxBody }}
  />
)
